<template>
  <q-page class="main">
    <common-form :action="$route('object-group.update', {objectGroup: objectGroup.id})" is-update>
      <q-card class="page-card">
        <q-card-section class="page-card__main-content">
          <h1 class="heading-2 q-mb-lg">{{ objectGroup.title }}</h1>
          <object-group-form :object-group="objectGroup"/>
          <div class="row q-mt-lg">
            <p class="no-margin">
              <i v-if="objectGroup.objects.length">Er zijn {{ objectGroup.objects.length }} objecten aan deze groep verbonden</i>
              <i v-else>Deze groep is niet in gebruik</i>
            </p>
          </div>
        </q-card-section>
        <q-separator/>
        <q-card-actions align="between" class="q-pa-md">
          <warning-button :disabled="objectGroup.objects.length" label="Verwijder subcategorie" @click="deleteSubcategory"/>
          <accent-button label="Opslaan" type="submit"/>
        </q-card-actions>
      </q-card>
      <sticky-top-bar />
    </common-form>
  </q-page>
</template>

<script>
import ObjectGroupForm from './ObjectGroupForm'

export default {
  components: {
    ObjectGroupForm
  },
  props: {
    objectGroup: {
      type: Object,
      default: null
    }
  },
  methods: {
    deleteSubcategory() {
      this.$goto('object-group.destroy', {objectGroup: this.objectGroup.id})
    }
  },
}
</script>
